import { createDataHook } from 'next-data-hooks';

import { productVariantIdentifierToIds } from '../../utils/_helper/product-variant-identifier-to-ids';
import { FullVariant } from '../models/full-variant';
import VariantService from '../services/variant.service';

export const useFullVariantByIdSsr = createDataHook<FullVariant>(
    'full-variant-by-id',
    async (context) => {
        const variantService = new VariantService();
        const variantResponse = await variantService.getFullVariant(
            productVariantIdentifierToIds(
                context?.params?.productVariantIdentifier as string
            ).variantId
        );
        return variantResponse.data;
    }
);
